import { fetchPayrollBasis } from "@/hooks/use-payroll-basis";
import { DAY_KIND_NB, type PayrollBasisEmployee } from "@/lib/overtime-calc";
import type { Grain, ReportContext, ReportResolver, ReportRow } from "@/lib/reports/types";

/**
 * Lønnsgrunnlag-rapporten (VIB-1224): ansatt-grain med sum tilleggstimer og
 * overnattinger; drill til grunnlagslinjer per føring (dato + type). INGEN
 * kroner (Erik 15.07) — lønn kjører satsene selv.
 */
export function lonnsgrunnlagRows(employees: PayrollBasisEmployee[]): ReportRow[] {
  return employees.map((e) => ({
    id: e.user_id,
    label: e.full_name,
    canDrill: true,
    cells: {
      tillegg: e.total_weekend_holiday_hours,
      netter: e.total_overnights,
    },
  }));
}

export function lonnsgrunnlagLineRows(emp: PayrollBasisEmployee | undefined): ReportRow[] {
  if (!emp) return [];
  return emp.lines.map((l) => ({
    id: l.entry_id,
    label: l.task_description,
    canDrill: false,
    cells: {
      dato: l.date,
      prosjekt: l.project_name,
      type: l.day_kind === "weekday" ? "—" : DAY_KIND_NB[l.day_kind],
      tillegg: l.weekend_holiday_hours,
      netter: l.overnight_count,
    },
  }));
}

export const lonnsgrunnlagResolver: ReportResolver = {
  async fetch(level: Grain, ctx: ReportContext): Promise<ReportRow[]> {
    const employees = await fetchPayrollBasis(ctx.period);
    if (level === "ansatt") return lonnsgrunnlagRows(employees);
    if (level === "oppgave") {
      const userId = ctx.drillPath[ctx.drillPath.length - 1]?.id;
      return lonnsgrunnlagLineRows(employees.find((e) => e.user_id === userId));
    }
    return [];
  },
};
